import React, { useState, useContext } from "react";
import PortfolioSimulatorCsv from "../components/PortfolioSimulatorCsv";
import FIRECalculator from "../components/FIRECalculator";
import CompoundGoalCalculator from "../components/CompoundGoalCalculator";
import RiskLab from "../components/RiskLab";
import "../components/PortfolioSimulatorCsv.css";
import "../components/FIRECalculator.css";
import "../components/CompoundGoalCalculator.css";
import Seo from "../components/Seo";
import { LangContext } from "../lang/LangProvider";
import { useAnalytics } from "../hooks/useAnalytics";

function L(lang, it, en) { return lang === "en" ? en : it; }

const TABS = (lang) => [
  { id: "etf",      label: L(lang, "Simulatore ETF",        "ETF Simulator")       },
  { id: "fire",     label: L(lang, "Calcolatore F.I.R.E.",  "F.I.R.E. Calculator") },
  { id: "compound", label: L(lang, "Calcolatore Obiettivi", "Goal Planner")         },
  { id: "risk",     label: L(lang, "Risk Lab",              "Risk Lab")             },
];
const TAB_IDS = ["etf", "fire", "compound", "risk"];

// Deep-link: /tools?tool=fire|compound|risk|etf (per i CTA da YouTube e dagli articoli KB)
const initialTab = () => {
  if (typeof window === "undefined") return "etf";
  const t = new URLSearchParams(window.location.search).get("tool");
  return TAB_IDS.includes(t) ? t : "etf";
};

const ToolsPage = () => {
  const { lang } = useContext(LangContext);
  const { trackTabSwitch } = useAnalytics();
  const [activeTab, setActiveTab] = useState(initialTab);

  const handleTabClick = (tabId) => {
    if (tabId !== activeTab) {
      trackTabSwitch(activeTab, tabId, lang);
      setActiveTab(tabId);
      if (typeof window !== "undefined") {
        const url = new URL(window.location.href);
        url.searchParams.set("tool", tabId);
        window.history.replaceState(null, "", url.pathname + url.search);
      }
    }
  };

  const seoTitle  = L(lang, "Strumenti finanziari gratuiti", "Free financial tools");
  const seoDesc   = L(lang,
    "Simulatore portafoglio ETF, calcolatore FIRE, calcolatore obiettivi e Risk Lab educativo. Strumenti a fini educativi con ipotesi dichiarate: non costituiscono consulenza in materia di investimenti né raccomandazioni personalizzate.",
    "ETF portfolio simulator, FIRE calculator, goal planner and educational Risk Lab. Educational tools with stated assumptions: not investment advice or personalised recommendations."
  );

  return (
    <>
      <Seo
        title={seoTitle}
        description={seoDesc}
        path={`/${lang}/tools`}
        image="/og/cover-tools.png"
      />
      <div className="simulator-bg">
        <div className="tools-tabs">
          {TABS(lang).map(tab => (
            <button
              key={tab.id}
              className={`tools-tab-btn${activeTab === tab.id ? " active" : ""}`}
              onClick={() => handleTabClick(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="tools-page">
          {activeTab === "etf"      && <PortfolioSimulatorCsv />}
          {activeTab === "fire"     && <FIRECalculator />}
          {activeTab === "compound" && <CompoundGoalCalculator />}
          {activeTab === "risk"     && <RiskLab />}
        </div>
      </div>
    </>
  );
};

export default ToolsPage;
